// extracted by mini-css-extract-plugin
module.exports = {"searchResult":"searchResult_searchResult__2FBcB","arrow":"searchResult_arrow__2Kq1j"};